/**
 * Participant visit edit URLs encode ptpID and ssvpID as one segment: `${ptpID}-${ssvpID}`.
 * React Router v6 cannot match the legacy v3 pattern `:ptpID-:ssvpID` in a single segment.
 */
export function parseParticipantVisitKey(visitKey = '') {
  const normalizedKey = String(visitKey)
  const dashIndex = normalizedKey.indexOf('-')

  if (dashIndex === -1) {
    return { ptpID: normalizedKey, ssvpID: '' }
  }

  return {
    ptpID: normalizedKey.slice(0, dashIndex),
    ssvpID: normalizedKey.slice(dashIndex + 1),
  }
}
